import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
  slots: {
    base: "relative border-b border-black pb-[1.2rem] group flex flex-col h-full",
    imageClass: "h-full w-full object-cover group-hover:scale-105 group-focus-within:scale-105 transition-transform duration-300",
    figureClass: "col-span-4 rounded-l overflow-hidden aspect-[33.5/26.5] lg:aspect-square",
    contentWrapper: "mt-2 flex flex-col grow",
    titleLink: 'after:content-[""] after:absolute after:top-0 after:left-0 after:size-full after:z-[3] after:cursor-pointer',
    desc: "mt-[0.5rem] max-w-[45ch] mb-4",
    informationsContainer: "flex justify-between items-center mt-auto",
  },
})

export type StylesVariants = VariantProps<typeof styles>
